import { render, staticRenderFns } from "./Fields.vue?vue&type=template&id=3cdf7074&scoped=true&"
import script from "./Fields.vue?vue&type=script&lang=js&"
export * from "./Fields.vue?vue&type=script&lang=js&"
import style0 from "./Fields.scss?vue&type=style&index=0&id=3cdf7074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdf7074",
  null
  
)

export default component.exports